const pagination = (() => {

	$(function () {
		if(document.querySelector('.js-pagination') !== null) {

			// カスタムデータ属性からコンテンツのタイプを取得
			// event or news
			const dataType = document.querySelector('.js-pagination').getAttribute('data-contents-name');

			// カスタムデータ属性から施設名を取得
			// TOREFARM or OUTDOOR DINING or WELLNESS LIVING
			const facilityName = document.querySelector('.js-pagination').getAttribute('data-facility-name');

			$('.js-pagination').pagination({
				dataSource: function(done){
					$.ajax({
						type: 'GET',
						url: '/api/' + dataType
					}).then(
						function(data) {
							// 施設名がセットされている場合はフィルターをかける
							if(facilityName) {
								data = data.filter(function(index) {
									// 各施設ページのNEWS/EVENT一覧は施設名のアイコンを非表示にするため、classNameを削除
									delete index.className;
									if(index.category === facilityName ) {
										return true;
									}
								});
							}
							done(data);
						},
						function() {
							console.log('error');
						}
					);
				},
				totalNumberLocator: function(response) {
					// you can return totalNumber by analyzing response content
					return Math.floor(Math.random() * (1000 - 100)) + 100;
				},

				pageSize: 12, //表示するコンテンツ数
				pageRange: 3, //選択されているページネーション番号の両隣に表示する個数
				ellipsisText: '...', //省略文字
				prevText: '«', //「前へ」の文字。エスケープ文字
				nextText: '»', //「次へ」の文字。エスケープ文字
				autoHidePrevious: true,
				autoHideNext: true,

				ajax: {
					beforeSend: function() {
						dataContainer.html('Loading ...');
					}
				},

				callback: function (data, pagination) {
					$('.js-display-cards').html(template(data));
				}
			});
		}

		function template(dataArray) {
			return dataArray.map(function(data) {
				return `
					<a href="${data.permalink}" class="article js-com-fade ${data.className}">
					  <div class="img-box">
						<div class="img"><picture>
						<img src="${data.thumbnail}"></picture></div>
					  </div>
					  <div class="data-box">
						<p class="date">${data.date}</p>
						<p class="copy">${data.title}</p>
					  </div>
					  <div class="btn-box">
						<div class="btn">
						  <p class="txt">READ MORE</p>
						  <div class="arrow"></div>
						</div>
					  </div>
					</a>
				`;
			})
		}
	});


})();
export default pagination;